import { useState, useEffect, useRef, useCallback } from "react";
import { config } from "core/utils";
var isValidThreshold = function (threshold) {
    return threshold >= 0 && threshold <= 1;
};
var useEnteredViewport = function (threshold) {
    var defaultThreshold = config.tracking.impressionThreshold.default;
    var getThreshold = function () { return threshold !== null && threshold !== void 0 ? threshold : defaultThreshold; };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var ref = useRef(null);
    var _a = useState(false), enteredViewport = _a[0], setEnteredViewport = _a[1];
    if (!isValidThreshold(getThreshold())) {
        throw new Error("Threshold is not valid, please enter a number between 0 and 1.");
    }
    var checkVisibility = useCallback(function () {
        if (ref.current) {
            // Calculate what the offset should be to conclude
            // when the element is visible enough based on the threshold.
            var pageYOffset = window.pageYOffset;
            var bottomViewportOffset = pageYOffset + window.innerHeight;
            var element = ref.current.getBoundingClientRect();
            // Add sticky mobile menu height when visible.
            var visibilityOffset = element.height * getThreshold() + element.top + pageYOffset;
            if (window.innerWidth < config.mobileNav.maxWidth) {
                visibilityOffset += config.mobileNav.height;
            }
            var visible = visibilityOffset < bottomViewportOffset;
            var becameVisible = visible && !enteredViewport;
            if (becameVisible) {
                setEnteredViewport(true);
                window.removeEventListener("scroll", checkVisibility);
                window.removeEventListener("resize", checkVisibility);
            }
            else {
                window.addEventListener("scroll", checkVisibility);
                window.addEventListener("resize", checkVisibility);
            }
        }
    }, []);
    useEffect(function () {
        checkVisibility();
    }, [ref]);
    return {
        enteredViewport: enteredViewport,
        ref: ref,
        checkVisibility: checkVisibility,
    };
};
export default useEnteredViewport;
